<template>
  <a-card :bordered="false">
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit" :cities="cities"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack" :cities="cities"></edit>
  </a-card>
</template>

<script>

import CityApi from '@/api/basicdata/api-city'
// 动态切换组件
import List from './SupplierList'
import Edit from './SupplierEdit'

export default {
  name: 'SupplierPage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true,
      // 城市信息列表
      cities: []
    }
  },
  mounted () {
    this.initLoad()
  },
  methods: {
    // 加载初始数据
    async initLoad () {
      const res = await CityApi.list()
      this.cities = res.data
    },
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
